(() => {
  const frameStorageKey = 'decollective:frame-preview';
  const validFrames = new Set(['none', 'oak', 'dark', 'black', 'white']);
  const savedFrame = () => {
    try {
      const value = localStorage.getItem(frameStorageKey);
      return validFrames.has(value) ? value : 'oak';
    } catch (_) {
      return 'oak';
    }
  };
  function init(section) {
    if (section.dataset.dcProductsReady === 'true') return;
    section.dataset.dcProductsReady = 'true';
    const track = section.querySelector('[data-dc-track]');
    const previous = section.querySelector('[data-carousel="previous"]');
    const next = section.querySelector('[data-carousel="next"]');
    if (!track || !previous || !next) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    for (const [button, direction] of [[previous, -1], [next, 1]]) {
      button.addEventListener('click', () => {
        const card = track.querySelector('.dc-home-products__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
    const frameButtons = [...section.querySelectorAll('[data-frame]')];
    const applyFrame = frame => {
      const selected = frameButtons.find(choice => choice.dataset.frame === frame);
      if (!selected) return;
      for (const choice of frameButtons) choice.setAttribute('aria-pressed', String(choice === selected));
      for (const overlay of section.querySelectorAll('.dc-home-product__frame')) {
        const card = overlay.closest('[data-dc-frame-orientation]');
        if (card) card.dataset.dcPreviewFrame = frame;
        if (selected.dataset.overlay) {
          overlay.src = selected.dataset.overlay;
          overlay.hidden = false;
        } else {
          overlay.hidden = true;
          overlay.removeAttribute('src');
        }
      }
    };
    applyFrame(savedFrame());
    for (const button of frameButtons) {
      button.addEventListener('click', () => {
        applyFrame(button.dataset.frame);
        try { localStorage.setItem(frameStorageKey, button.dataset.frame); } catch (_) {}
      });
    }
  }
  const initAll = root => root.querySelectorAll('[data-dc-products]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
